/* unplugin-vue-components disabled */import { render } from "./edit-topic.vue?vue&type=template&id=b71095c6&scoped=true"
import script from "./edit-topic.vue?vue&type=script&lang=js"
export * from "./edit-topic.vue?vue&type=script&lang=js"

import "./edit-topic.vue?vue&type=style&index=0&id=b71095c6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b71095c6"],['__file',"src/pages/pulse/tracker/edit-topic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b71095c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b71095c6', __exports__)) {
    api.reload('b71095c6', __exports__)
  }
  
  module.hot.accept("./edit-topic.vue?vue&type=template&id=b71095c6&scoped=true", () => {
    api.rerender('b71095c6', render)
  })

}


export default __exports__